var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleet16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.85 12.35L13.85 14.35C13.8054 14.3981 13.7511 14.4362 13.6909 14.4621C13.6306 14.4879 13.5656 14.5008 13.5 14.5H0V13.5H13.29L14.79 12L14.29 11.5H5.46C5.32116 11.4778 5.19612 11.4032 5.11056 11.2916C5.02501 11.18 4.98545 11.0399 5 10.9V9.10004C4.98545 8.96018 5.02501 8.82006 5.11056 8.70847C5.19612 8.59687 5.32116 8.52229 5.46 8.50003H11.29L10.29 7.50003H0V6.50003H10.5C10.5656 6.49924 10.6306 6.51217 10.6909 6.538C10.7511 6.56384 10.8054 6.602 10.85 6.65003L13.5 9.29003L13.79 9.00003L12.5 7.71003L11.79 7.00003L10.29 5.50003H2V4.50003H10.5C10.5656 4.49924 10.6306 4.51217 10.6909 4.538C10.7511 4.56384 10.8054 4.602 10.85 4.65003L12.5 6.29003L12.79 6.00003L10.29 3.50003H4V2.50003H10.5C10.5656 2.49924 10.6306 2.51217 10.6909 2.538C10.7511 2.56384 10.8054 2.602 10.85 2.65004L13.85 5.65003C13.8978 5.69493 13.936 5.74914 13.962 5.80934C13.9881 5.86954 14.0015 5.93444 14.0015 6.00003C14.0015 6.06563 13.9881 6.13053 13.962 6.19073C13.936 6.25093 13.8978 6.30514 13.85 6.35003L13.21 7.00003L14.85 8.65003C14.8978 8.69492 14.936 8.74914 14.962 8.80934C14.9881 8.86954 15.0015 8.93444 15.0015 9.00003C15.0015 9.06563 14.9881 9.13053 14.962 9.19073C14.936 9.25093 14.8978 9.30515 14.85 9.35004L14.21 10L15.85 11.65C15.8978 11.6949 15.936 11.7491 15.962 11.8093C15.9881 11.8695 16.0015 11.9344 16.0015 12C16.0015 12.0656 15.9881 12.1305 15.962 12.1907C15.936 12.2509 15.8978 12.3051 15.85 12.35Z",
    fill: "#464646"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleet16);
export default __webpack_public_path__ + "static/media/fleet16.c3ef98ebdb82e99db452064226449a62.svg";
export { ForwardRef as ReactComponent };